import {
  ContentCard,
  type ContentCardProps,
} from '@tuic/web-compositions/shared/ContentCard';

import type { ComponentBlock } from '@modules/prism-client/types/types';

export type ContentCardBlockData = ContentCardProps;

export const ContentCardBlock: ComponentBlock<ContentCardBlockData> = ({
  data,
  fallback,
}) => {
  if (fallback) {
    return <ContentCard fallback />;
  }

  if (!data) {
    return null;
  }

  return <ContentCard {...data} />;
};
